module.exports = __webpack_public_path__ + "static/media/ic_nav_04_selected.84583878.svg";